var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor-panel__row"},[_c('span',{staticClass:"editor-panel__row-label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"editor-panel__row-field"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }